import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BookingCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const jobId = searchParams.get("o");
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    const updateBooking = async () => {
      try {
        await axios.post(
          "https://highwycombebites.com/api/booking/ConfirmDiningBooking",
          {
            bookingid: parseInt(jobId),
            sessionid: sessionId,
            paymentstatus: "Failed",
          }
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (jobId) updateBooking();
  }, [jobId, sessionId]);

  return (
    <>
      <Navbar />

      <div className="payment-page cancel-bg">
        <div className="payment-card">

          <div className="status-icon cancel-icon">✕</div>

          <h1 className="payment-title">Payment Cancelled</h1>

          <p className="payment-subtitle">
            Your payment was not completed.  
            Don’t worry — you can try again anytime.
          </p>

          <div className="payment-actions">
            <button
              className="primary-btn"
              onClick={() => navigate(-1)}
            >
              Try Again
            </button>

            <button
              className="outline-btn"
              onClick={() => navigate("/")}
            >
              Back to Home
            </button>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default BookingCancel;
